import { Controller } from "@hotwired/stimulus"
import JSONEditor from 'jsoneditor'

export default class extends Controller {
  static targets = [ "textarea" ]

  connect() {
    // console.log("Hello, Active Admin JSON Controller here!", this.element);
    // console.log(this.textareaTarget);
  }

  makeJson(event) {
    event.preventDefault();

    // console.log("Making JSON");
    // console.log(this.textareaTarget.value);

    const container = document.createElement('div')
    container.classList.add('jsoneditor-container')
    this.textareaTarget.parentElement.appendChild(container)

    // Create error message element
    this.errorMessage = document.createElement('div')
    this.errorMessage.classList.add('jsoneditor-error-message')
    this.errorMessage.style.cssText = 'display: none; color: #d32f2f; background: #ffebee; padding: 12px; margin-top: 8px; border-radius: 4px; border-left: 4px solid #d32f2f;'
    this.textareaTarget.parentElement.appendChild(this.errorMessage)

    // Track validation state
    this.hasErrors = false

    // Store the editor instance for later access
    this.editor = new JSONEditor(container, {
      modes: ['code', 'tree'],
      // Sync changes back to textarea whenever the content changes
      onChange: () => {
        this.syncToTextarea()
      },
      // Handle validation errors
      onValidationError: (errors) => {
        this.handleValidationErrors(errors)
      },
      // Handle text changes in code mode to catch parsing errors
      onChangeText: (jsonString) => {
        try {
          JSON.parse(jsonString)
          this.clearErrors()
        } catch (error) {
          this.handleParseError(error)
        }
      }
    })

    try {
      let json_data = JSON.parse(this.textareaTarget.value)
      if (json_data) {
        this.editor.set(json_data);
      }
    } catch (error) {
      console.error(`Error parsing JSON: ${error}`)
    }

    this.textareaTarget.style.display = 'none'

    // Also sync on form submission as a backup
    this.setupFormSubmitHandler()
  }

  syncToTextarea() {
    try {
      // Get the JSON from the editor and stringify it with pretty formatting
      const json = this.editor.get()
      this.textareaTarget.value = JSON.stringify(json, null, 2)
    } catch (error) {
      console.error('Error syncing JSONEditor to textarea:', error)
    }
  }

  setupFormSubmitHandler() {
    // Find the parent form
    const form = this.textareaTarget.closest('form')
    if (form) {
      // Store form reference for later use
      this.form = form

      // Sync textarea before submit
      form.addEventListener('submit', () => {
        this.syncToTextarea()
      }, { once: false })

      // Prevent form submission if there are JSON errors
      form.addEventListener('submit', (e) => {
        if (this.hasErrors) {
          e.preventDefault()
          e.stopPropagation()
          this.showErrorMessage('Cannot save: Please fix JSON errors before submitting.')
          return false
        }
      }, { capture: true })
    }
  }

  handleValidationErrors(errors) {
    this.hasErrors = errors && errors.length > 0
    this.updateSubmitButton()

    if (this.hasErrors) {
      const errorCount = errors.length
      const errorText = errorCount === 1 ? 'error' : 'errors'
      this.showErrorMessage(`JSON validation failed: ${errorCount} ${errorText} found. Please fix before saving.`)
    } else {
      this.clearErrors()
    }
  }

  handleParseError(error) {
    this.hasErrors = true
    this.updateSubmitButton()
    this.showErrorMessage(`Invalid JSON: ${error.message}. Please fix the syntax before saving.`)
  }

  clearErrors() {
    this.hasErrors = false
    this.updateSubmitButton()
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none'
    }
  }

  showErrorMessage(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message
      this.errorMessage.style.display = 'block'
    }
  }

  updateSubmitButton() {
    if (!this.form) return

    // Find all submit buttons in the form
    const submitButtons = this.form.querySelectorAll('input[type="submit"], button[type="submit"]')

    submitButtons.forEach(button => {
      if (this.hasErrors) {
        button.disabled = true
        button.style.opacity = '0.5'
        button.style.cursor = 'not-allowed'
      } else {
        button.disabled = false
        button.style.opacity = '1'
        button.style.cursor = 'pointer'
      }
    })
  }

  disconnect() {
    // Clean up the editor when the controller is disconnected
    if (this.editor) {
      this.editor.destroy()
    }
  }

}
